const servicesData = [
  {
    id: 'website-design',
    title: 'Website Design & Development',
    shortDesc: 'We create modern, responsive, and SEO-friendly websites that help businesses establish a strong online presence.',
    image: 'https://images.unsplash.com/photo-1467232004584-a241de8bcf5d?auto=format&fit=crop&w=1600&q=80',
    details: [
      'Custom responsive website design tailored to your brand',
      'Mobile-first development for seamless experience across devices',
      'SEO-optimized structure to improve search engine visibility',
      'Fast loading speed and performance optimization',
      'Content Management System (CMS) integration on request',
      'Ongoing support and maintenance after launch'
    ]
  },
  {
    id: 'custom-software',
    title: 'Custom Software Development',
    shortDesc: 'We develop custom software solutions tailored to your business requirements, improving productivity and efficiency.',
    image: 'https://images.unsplash.com/photo-1461749280684-dccba630e2f6?auto=format&fit=crop&w=1600&q=80',
    details: [
      'Requirement analysis and solution architecture',
      'Custom-built software matching your exact workflow',
      'Scalable and secure development practices',
      'Integration with existing business tools',
      'Dedicated testing and quality assurance',
      'Post-deployment support and upgrades'
    ]
  },
  {
    id: 'business-management',
    title: 'Business Management Software',
    shortDesc: 'Complete ERP, CRM, inventory, billing, and employee management systems for small and medium businesses.',
    image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=1600&q=80',
    details: [
      'ERP systems to unify business operations',
      'CRM tools to manage customer relationships',
      'Inventory and stock management',
      'Automated billing and invoicing',
      'Employee management and payroll modules',
      'Real-time dashboards and reporting'
    ]
  },
  {
    id: 'ecommerce',
    title: 'E-Commerce Development',
    shortDesc: 'Build secure online stores with payment gateway integration, product management, and order tracking.',
    image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&w=1600&q=80',
    details: [
      'Custom online store design and setup',
      'Secure payment gateway integration',
      'Product catalog and inventory management',
      'Order tracking and customer notifications',
      'Mobile-friendly shopping experience',
      'Admin dashboard for managing sales'
    ]
  },
  {
    id: 'mobile-app',
    title: 'Mobile App Development',
    shortDesc: 'Android and iOS applications designed to help businesses connect with customers anytime, anywhere.',
    image: 'https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?auto=format&fit=crop&w=1600&q=80',
    details: [
      'Native and cross-platform app development',
      'Android and iOS compatibility',
      'Intuitive UI/UX design',
      'Push notifications and real-time updates',
      'API integration and backend connectivity',
      'App store submission support'
    ]
  },
  {
    id: 'cloud-web',
    title: 'Cloud & Web Application Development',
    shortDesc: 'Scalable web applications using modern technologies for startups and growing enterprises.',
    image: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&w=1600&q=80',
    details: [
      'Cloud-based scalable architecture',
      'Modern frameworks for fast performance',
      'Secure user authentication and data handling',
      'API development and third-party integrations',
      'Deployment on cloud platforms (AWS, Vultr, etc.)',
      'Continuous monitoring and scaling support'
    ]
  },
  {
    id: 'maintenance-support',
    title: 'Software Maintenance & Support',
    shortDesc: 'We provide regular updates, bug fixes, performance improvements, and technical support after deployment.',
    image: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&w=1600&q=80',
    details: [
      'Regular software updates and patches',
      'Bug fixing and issue resolution',
      'Performance monitoring and optimization',
      'Security updates and vulnerability checks',
      '24/7 technical support options',
      'Scheduled maintenance plans'
    ]
  },
  {
    id: 'it-consulting',
    title: 'IT Consulting & Digital Solutions',
    shortDesc: 'Expert guidance to help businesses choose the right technology and digital solutions for long-term growth.',
    image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=1600&q=80',
    details: [
      'Technology strategy and consulting',
      'Digital transformation roadmaps',
      'Software and infrastructure recommendations',
      'Cost-effective solution planning',
      'Vendor and tool evaluation support',
      'Long-term technology growth planning'
    ]
  }
];

export default servicesData;